export const getParamsFromUrl = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (!urlParams.get('lat') || !urlParams.get('lng')) return null;
    return {
        markers: [],
        coordinates: {
            lat: Number(urlParams.get('lat')),
            lng: Number(urlParams.get('lng')),
            zoom: Number(urlParams.get('zoom')),
        },
    };
}

export const setParamsToUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('lat', '50.1003');
    url.searchParams.set('lng', '14.2555');
    window.location.replace(url.href);
}